/* eslint-disable @typescript-eslint/no-explicit-any */
import BreadCrumb from '@/components/breadCrumb';
import { useTranslation } from '@/i18n/client';
import { addCartUtil } from '@/utils/cartUtils';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { observer } from 'mobx-react';
import { lazy, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import CommonButton from './components/commonButton';
import OrderDetailComponents from './components/orderDetailComponents';
import styles from './orderDetail.module.scss';
// 埋点
import { SceneCode } from '@/apis/recommend/recommend.interface';
import { sendPv } from '@/tracks/25344';
import {
  EXPOSURE_RECORD as Recommend_EXPOSURE_RECORD,
  sendClickTrack as Recommend_sendClickTrack,
} from '@/tracks/25355';

const RecommendClient = lazy(() => import('@/components/recommend/recommendClient'));

const OrderDetail = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [orderDetails, setOrderDetails] = useState<IOrderDetailRes | null>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [productSkuIds, setProductSkuIds] = useState(''); // 逗号分隔的字符串skuid
  const [isEmptyPage, setIsEmptyPage] = useState<boolean>(false);
  // const [error, setError] = useState<string | null>(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const orderId = queryParams.get('orderId') || ''; // 获取订单ID
  const isBack = queryParams.get('isBack') ? Boolean(queryParams.get('isBack')) : false; // 是否需要返回上一个页面

  useEffect(() => {
    sendPv.OrderCenter_Detail();
    window.scrollTo(0, 0); // 页面跳转时滚动到顶部
  }, []);

  const recommendAddCart = (item: { skuId: string }) => {
    addCartUtil([{ skuId: item?.skuId, num: '1' }], true);
  };

  const pageLoadedHandler = (productSkuIds: any) => {
    setIsLoaded(true);
    if (productSkuIds.length > 0) {
      const firstTenItems = productSkuIds.slice(0, Math.min(productSkuIds.length, 10));
      setProductSkuIds(firstTenItems.join(','));
    }
  };

  return !isEmptyPage ? (
    <div className={styles.order_detail_wrap}>
      <Helmet>
        <title>{`${t('seo.title.orderDetail', { orderId: '#' + orderId || '' })}} | Joybuy`}</title>

        <meta name='description' content={t('seo.description.orderDetail')} />
      </Helmet>
      <div className={styles.detail_inner_wrap}>
        <BreadCrumb
          list={[
            { name: t('common.pageName.me'), url: '/profile' },
            { name: t('common.pageName.myOrders'), url: '/profile/my-orders' },
            { name: t('order.orderList.orderItems.headerOrderdetail') },
          ]}
        />
        <div className={styles.order_content} id='orderDetail_page_container'>
          <OrderDetailComponents
            orderId={orderId}
            pageLoadedHandler={pageLoadedHandler}
            changePageHandler={(val) => {
              setIsEmptyPage(val);
            }}
          />
        </div>
        {isLoaded && (
          <RecommendClient
            sceneCode={SceneCode.ORDER_DETAIL}
            mainSkus={productSkuIds}
            addCartFn={recommendAddCart}
            trackParams={{
              RecomSku_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_Detail_RecomSku_Expo,
              RecomSku_Tab_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_Detail_RecomSku_Tab_Expo,
              RecomSku_Addcart_Expo:
                Recommend_EXPOSURE_RECORD.OrderCenter_Detail_RecomSku_Addcart_Expo,
              productClick: Recommend_sendClickTrack.OrderCenter_Detail_RecomSku,
              tabClick: Recommend_sendClickTrack.OrderCenter_Detail_RecomSku_Tab,
              addCartClick: Recommend_sendClickTrack.OrderCenter_Detail_RecomSku_Addcart,
            }}
          />
        )}
      </div>
    </div>
  ) : (
    <div className={styles.emptyBlock}>
      {/* 已删除的订单详情拦截弹框 */}
      <Dialog open={isEmptyPage}>
        <DialogContent>{t('order.orderDetail.deletedModal.modalContent')}</DialogContent>

        {/* Button */}
        <DialogActions>
          <CommonButton
            variant='contained'
            onClick={() => {
              if (isBack) {
                // 从积分页面进入，需要返回积分页面
                navigate(-1);
              } else {
                navigate('/profile/my-orders', { replace: true });
              }
            }}
          >
            {t('order.orderDetail.deletedModal.btnText')}
          </CommonButton>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default OrderDetail;
